import React, { useState, useEffect } from 'react';
// import './Sidebar.css'; // 假設你有一個簡單的 CSS 文件來處理樣式
import AIBotWrapper from './AIBotWrapper.js';
import UploadWrapper from '../components/UploadWrapper.js';
import { PageLayout } from '../components/Auth/PageLayout.js';
import MainContent from './MicrosoftAuthWrapper.js';
import { MainDropdown } from '../components/MainDropdown.js';
import AzureOpenAIWrapper from './AzureOpenAIWrapper.js';
import Order from '../components/Order.js';
import ChatApp from './ChatApp.js';
import Attendance from './Attendance.js';
import Case from './Case.js';
import TopicChat from './TopicChat.js';
import MeetingChat from './MeetingChat.js';
import UserList from '../components/UserList.js';
import PrivateChat from './PrivateChat.js';
import { useAuthContext } from '../contexts/AuthContext.js';
import { useNewChatContext } from '../contexts/NewChatContext.js';
import ConversationList from '../components/ConversationList.js';
import ConversationWrapper from './ConversationWrapper.js';
import RunwayDemo from '../components/Runway.js';
import DraggableCard from '../components/DraggableCard.js';
import TestMailButton from './TestMailButton.js';
import ChannelList from '../components/ChannelList.js';


const Sidebar = () => {
  const { AuthData, updateAuthData, user, setUser } = useAuthContext();
  const { newChatId, setNewChatId, setNewChatInput } = useNewChatContext();

  const [isOpen, setIsOpen] = useState(false);
  const [activeComponent, setActiveComponent] = useState(null);
  const [caseNames, setCaseNames] = useState([]);
  const [selectedProjectData, setSelectedProjectData] = useState(null);
  const [selectedCaseId, setSelectedCaseId] = useState(null);
  const [topics, setTopics] = useState([]);
  const [meetings, setMeetings] = useState([]);
  const [selectedtopic, setSelectedTopic] = useState(null);
  const [selectedmeeting, setSelectedMeeting] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null)
  const [selectedConversation, setSelectedConversation] = useState(null)
    const [ordersDetails, setOrdersDetails] = useState([]);

  const fetchCaseName = async () => {
    try {
      const response = await fetch('http://localhost:5000/get_case_name')
      const data = await response.json()
      console.log('fetchCaseName data:', data)
      setCaseNames(data.case_name)
    } catch (error) {
      console.error('Error fetching case name:', error);
    }
  }
  useEffect(() => {
    fetchCaseName();
    // fetch('/get_case_name')
    //   .then(res => res.json())
    //   .then(data => setCaseNames(data.map(item => item.case_name)))
    //   .catch(err => console.error(err));
  }, []);
  useEffect(() => {
    console.log('caseNames:', caseNames)
  }, [caseNames]);


  // useEffect(() => {
  //   const adjustSidebarHeight = () => {
  //     const appContainer = document.querySelector('.app-container');
  //     const sidebar = document.querySelector('.sidebar');
  //     sidebar.style.height = `${appContainer.offsetHeight}px`;
  //   };

  //   window.addEventListener('resize', adjustSidebarHeight);
  //   adjustSidebarHeight();
  //   console.log("視窗大小改變");

  //   return () => window.removeEventListener('resize', adjustSidebarHeight);
  // }, []);


  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const renderContent = () => {
    switch (activeComponent) {
      case 'Login':
        return (
          <PageLayout>
            <center>
              <MainContent />
            </center>
          </PageLayout>);
      case 'NewChat':
        return <AzureOpenAIWrapper setActiveComponent={setActiveComponent}
          setSelectedConversation={setSelectedConversation} />;
      case 'ConversationWrapper':
        return <ConversationWrapper
        // 變動的 key切對話時強制重新掛載，內部暫存狀態（輸入框、暫存訊息）就會被重置
          key={selectedConversation?.id ?? newChatId ?? 'new'} 
          selectedConversation={selectedConversation} />;
      case 'Case':
        return <Case selectedProjectData={selectedProjectData}
          topics={topics}
          activeComponent={activeComponent}
          setActiveComponent={setActiveComponent}
          setSelectedTopic={setSelectedTopic}
          ordersDetails={ordersDetails}
        />;
      case 'TopicChat':
        return <TopicChat selectedProjectData={selectedProjectData}
          selectedtopic={selectedtopic}
        // topics={topics}
        />;
      case 'MeetingChat':
        return <MeetingChat selectedProjectData={selectedProjectData}
          selectedmeeting={selectedmeeting}
        // topics={topics}
        />;
      // case 'ChatApp':
      //   return <ChatApp />;
      case 'Attendance':
        return <Attendance />;
      // case 'AI Bot':
      //   return <MainDropdown options={['Abstract', 'Database']} />;
      // case 'AIAbstract':
      //   return <AIBotWrapper />;
      // case 'Upload':
      //   return <UploadWrapper />;
      case 'PrivateChat':
        return <PrivateChat selectedUser={selectedUser} />;
      case 'Runway':
        return <RunwayDemo />;
      default:
        return <div>Please select an option from the sidebar.</div>;
    }
  };



  return (
    <div className="app-container">
      <div className="happy">ha-pp-y™ Co.</div>
      {/* <div className={`${isOpen ? 'open' : 'closed'}`}> */}
      {/* <button className="toggle-button" onClick={toggleSidebar}>
          {isOpen ? 'Close' : 'Open'}
        </button>
        {isOpen && ( */}
      <div className="menu">
        <div className="new-chat"
          onClick={() => {
            setSelectedConversation(null);
            setNewChatId(null);
            setNewChatInput(null);
            setActiveComponent('NewChat');
          }}>
          <img src='./chat.png' style={{ width: "13%" }}></img>
          <div className="">New chat</div>
        </div>
        <ConversationList
          setActiveComponent={setActiveComponent}
          setSelectedConversation={setSelectedConversation}
          selectedUser={selectedUser}
          selectedConversation={selectedConversation} />
        {/* <div className="menu-item">
            <img src='./logo192.png' style={{ width: "13%" }}></img>
            <div className="" onClick={() => setActiveComponent('ChatApp')}>Chat</div>
          </div> */}
        {/* <div style={{ marginLeft: '20px', fontSize: '14px' }}> */}
        <ChannelList
          setActiveComponent={setActiveComponent}
          caseNames={caseNames}
          selectedCaseId={selectedCaseId}          
          setSelectedCaseId={setSelectedCaseId}
          topics={topics}
          setTopics={setTopics}
          setSelectedTopic={setSelectedTopic}
          selectedtopic={selectedtopic}
          selectedProjectData={selectedProjectData}
          setSelectedProjectData={setSelectedProjectData}
          meetings={meetings}
          setMeetings={setMeetings}
          selectedmeeting={selectedmeeting}
          setSelectedMeeting={setSelectedMeeting}
          ordersDetails={ordersDetails}
          setOrdersDetails={setOrdersDetails}
        // handleCaseClick={handleCaseClick}
        />
        {/* <p className="menu-item" onClick={() => setActiveComponent('AI Bot')}>AI Bot</p> */}
        {/* <p className="menu-item" onClick={() => setActiveComponent('AIAbstract')}>AIAbstract</p>
            <p className="menu-item" onClick={() => setActiveComponent('Upload')}>Database</p> */}

        {/* {AuthData.flaskAccessToken && } */}
        <UserList
          setActiveComponent={setActiveComponent}
          setSelectedUser={setSelectedUser}
          selectedUser={selectedUser} />

        <div className="menu-item" onClick={() => setActiveComponent('Attendance')}>
          <img src='./logo192.png' style={{ width: "13%" }}></img>
          <div className="">Attendance</div>
        </div>

        {/* <TestMailButton /> */}
        {/* <div className="menu-item">
            <img src='./logo192.png' style={{ width: "13%" }}></img>
            <div className="" onClick={() => setActiveComponent('Runway')}>Runway</div>
          </div> */}
      </div>
      {/* )} */}

      {/* </div> */}
      <div className="green-button login-button" onClick={() => setActiveComponent('Login')}>

        <img src='./arrow03.png' style={{ width: "35%" }}></img>
        <div
          style={{ cursor: 'pointer' }}
        >
          {user?"Logout":"Login"}
        </div>
        {/* <div className="" onClick={() => setActiveComponent('Login')}>Login</div> */}
      </div>
      <div className="content-area">
        {renderContent()}
        {/* <DraggableCard /> */}
      </div>
    </div>
  );
};

export default Sidebar;
